import { zIndices } from '../../../theme/foundations';
export var tooltipTheme = {
  baseStyle: _ref => {
    var {
      position,
      top,
      left
    } = _ref;
    return {
      title: {
        textStyle: 'body4Semi',
        display: 'inline-flex'
      },
      trigger: {
        display: 'inline-flex',
        maxWidth: '100%',
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineOffset: '2px'
        }
      },
      content: {
        position,
        top: "".concat(top !== null && top !== void 0 ? top : 0, "px"),
        left: "".concat(left !== null && left !== void 0 ? left : 0, "px"),
        backgroundColor: 'neutral.black',
        color: 'neutral.white',
        border: 'none',
        borderRadius: 'l',
        paddingX: 's',
        paddingY: 'xs',
        textStyle: 'body4',
        width: 'max-content',
        maxWidth: '296px',
        textAlign: 'start',
        zIndex: 'tooltip',
        boxShadow: 0,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        _focus: {
          boxShadow: 0
        }
      }
    };
  }
};
export var fadeStyle = {
  position: 'absolute',
  zIndex: zIndices.tooltip
};
//# sourceMappingURL=Tooltip.theme.js.map